/**
 * Debounces a function to be called on the next microtask.
 *
 * @internal scope: workspace
 */
export function debounceMicrotask(fn) {
    let scheduled = false;
    let latestThis;
    let latestArgs;
    const debounced = function (...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        latestThis = this;
        latestArgs = args;
        if (scheduled)
            return;
        scheduled = true;
        queueMicrotask(() => {
            if (!scheduled)
                return;
            scheduled = false;
            fn.apply(latestThis, latestArgs);
        });
    };
    const cancel = () => {
        scheduled = false;
    };
    const flush = () => {
        if (!scheduled)
            return;
        scheduled = false;
        fn.apply(latestThis, latestArgs);
    };
    return Object.assign(debounced, { cancel, flush });
}
